import { Image } from './Image';
import { Localization } from './Localization';
import { Media } from './Media';
import { Video } from './Video';

export class Slide {
  constructor(
    private _media: Media,
    private _position: number = 0,
    private _total: number = 0
  ) {}

  getAlt(localization: Localization): string {
    return (
      this._media.alt ?? localization('image-alt-text').replace('{0}', this._position.toString())
    );
  }

  get position(): number {
    return this._position;
  }

  set position(position: number) {
    this._position = position;
  }

  set total(total: number) {
    this._total = total;
  }

  get galleryId(): string {
    return `gallery-${this._position}`;
  }

  get thumbnailId(): string {
    return `thumbnail-${this._position}`;
  }

  get thumbnail(): string {
    return this._media.thumbnail;
  }

  get media(): Media {
    return this._media;
  }

  get isVideo(): boolean {
    return this._media instanceof Video;
  }

  get isImage(): boolean {
    return this._media instanceof Image;
  }

  copy(): Slide {
    return new Slide(this._media.copy(), this._position, this._total);
  }

  equals(slide: Slide): boolean {
    return (
      this._media.equals(slide._media) &&
      this._position === slide._position &&
      this._total === slide._total
    );
  }
}
